import Button from "@/Components/Button/Button";
import Select from "@/Components/Select/Select";
import { SettingsField } from "@/Components/WebsiteSettings/SettingsCard";
import { themeListAtom } from "@/shared/atoms";
import { themeType } from "@/shared/utils/constant";
import { useAtom } from "jotai";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const ColorTemplate = () => {
  const { t } = useTranslation("", { keyPrefix: "settings_page" });
  const { control } = useFormContext();
  const [themeList] = useAtom(themeListAtom);
  const history = useHistory();

  return (
    <SettingsField
      data-tour="website-settings.color-template"
      label={t("colorTemplate")}
      hint={t("cards.colorTemplateHint")}
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <div className="min-w-0 flex-1">
          <Controller
            name="colorTemplate"
            control={control}
            render={({ value, onChange }) => (
              <Select
                onChange={(val) => onChange(val)}
                options={themeList.filter(
                  (i) => i.themeType === themeType.CUSTOM
                )}
                getOptionLabel={(option) => option.template_name}
                getOptionValue={(option) => option.item_id}
                value={value}
              />
            )}
          />
        </div>
        <Button
          type="button"
          variant="secondary"
          onClick={() => history.push("/websitesettings/themes")}
        >
          {t("cards.manageThemes")}
        </Button>
      </div>
    </SettingsField>
  );
};

export default ColorTemplate;
